import React, { forwardRef, useEffect, useState } from 'react';
import { FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { clsx } from 'clsx';
import { type BasicShopUIPropTypes, type BuyerLayoutProps } from 'shop-ui/types';
import { ProductPrice } from './ProductPrice';
import { ProductHeading } from './ProductHeading';
import { ProductSummary } from './ProductSummary';
import { ProductSpecPicker } from './ProductSpecPicker';
import { ProductCartCounter } from './ProductCartCounter';
import { ProductCartButtons } from './ProductCartButtons';
import { SSR } from './ssr';
import STYLE from './ProductInfoGroup.module.scss';

interface ProductInfoGroupProps extends BasicShopUIPropTypes, BuyerLayoutProps<Product> {
    // 自行加入其他 props
    content: string;
}

export const ProductInfoGroup = forwardRef<HTMLDivElement, ProductInfoGroupProps>(
    (props, ref) => {
        const [hydrated, setHydrated] = useState(false);

        const { styleMap, style, isEditingMode, isBuyer, __ssr } = props;

        const type = styleMap ? styleMap[FEATURE_FLAG_KEYS.PRODUCT_INFO_GROUP_TYPE] : '';

        useEffect(() => {
            setHydrated(true);
        }, []);

        if (!hydrated && isBuyer) {
            return (
                <div>
                    <SSR.ProductHeading __ssr={__ssr} />
                    <div className="skeleton-spacer"></div>
                    <SSR.ProductPrice __ssr={__ssr} />
                    <SSR.ProductSummary __ssr={__ssr} />
                    <SSR.ProductSpecPicker __ssr={__ssr} />
                    <div className="skeleton-spacer"></div>
                    <SSR.ProductCartCounter />
                    <div className="skeleton-spacer"></div>
                    <SSR.ProductCartButtons __ssr={__ssr} />
                </div>
            );
        }

        return (
            <div ref={ref} style={style} className={clsx(STYLE.root, STYLE.shrinkGap)}>
                <ProductHeading isBuyer={isBuyer} />
                <ProductPrice isBuyer={isBuyer} />
                <ProductSummary type={type} />
                <ProductSpecPicker
                    type={type}
                    isEditingMode={isEditingMode}
                    isBuyer={isBuyer}
                />
                <ProductCartCounter />
                <ProductCartButtons type={type} />
            </div>
        );
    }
);

ProductInfoGroup.displayName = 'ProductInfoGroup';
